import { Option } from '../Select/Createable';
import { useState, useEffect } from 'react';
import { createClient } from '@/utils/supabase/client';
import { FORMAT, GEAR } from '@/utils/constants';
import { GearIcon } from '@/components/icons/Gear';
import { Tone } from '@/utils/helpers';
import { Searchable } from '../Select/Searchable';
interface Props {
  onChange: (option: Option | undefined) => void;
  userId: string | undefined;
  platform?: FORMAT;
  defaultTone?: Tone | null;
  excludeToneId: number;
}

export const TonesSearchable = ({
  onChange,
  userId,
  platform = FORMAT.NAM,
  defaultTone,
  excludeToneId,
}: Props) => {
  const [options, setOptions] = useState<Option[]>(
    defaultTone
      ? [
          {
            label: defaultTone.title,
            value: defaultTone.id,
            icon: <GearIcon size={24} gear={defaultTone.gear as GEAR} />,
          },
        ]
      : []
  );
  const [search, setSearch] = useState('');
  const supabase = createClient();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (defaultTone) {
      onChange({
        label: defaultTone.title,
        value: defaultTone.id,
        icon: <GearIcon size={24} gear={defaultTone.gear as GEAR} />,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!userId) return;
    // Fetch tones from supabase
    const fetchTones = async () => {
      setLoading(true);
      const { data, error } = await supabase
        .from('tones')
        .select('id, title, gear')
        .eq('user_id', userId)
        .eq('platform', platform)
        .neq('id', excludeToneId)
        .ilike('title', `%${search}%`)
        .order('updated_at', { ascending: false });

      if (error) {
        console.error(error);
      } else {
        const newOptions = data.map((tone) => ({
          label: tone.title,
          value: tone.id,
          icon: <GearIcon size={24} gear={tone.gear as GEAR} />,
        }));
        if (
          defaultTone &&
          !search &&
          !newOptions.find((option) => option.value === defaultTone.id)
        ) {
          newOptions.unshift({
            label: defaultTone.title,
            value: defaultTone.id,
            icon: <GearIcon size={24} gear={defaultTone.gear as GEAR} />,
          });
        }
        setOptions(newOptions);
      }
      setLoading(false);
      setLoading(false);
    };

    fetchTones();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, userId, defaultTone]);

  return (
    <Searchable
      label={'Tone Pack*'}
      options={options}
      onChange={onChange}
      onSearch={setSearch}
      loading={loading}
      defaultOption={defaultTone ? defaultTone.id : undefined}
    />
  );
};
